/**
 * debug-mode — per-zařízení přepínač „debug módu" pro adminy. Když je zapnutý,
 * `DebugOverlay` zobrazí na obrazovce chyby zachycené `debug-log.ts` (užitečné na
 * mobilní PWA, kde nejsou DevTools). Stav žije jen v localStorage tohoto zařízení
 * (žádný backend) — je to ladicí pomůcka, ne sdílené nastavení.
 *
 * Viditelnost přepínače i overlaye je navíc gatovaná rolí (admin) v komponentách.
 */

export const DEBUG_MODE_KEY = "bw:debug";
export const DEBUG_CHANGED_EVENT = "bw:debug-changed";
/** Trvalé skrytí bug ikony z menu (per-zařízení). Admin si ji může vypnout natrvalo. */
export const DEBUG_HIDDEN_KEY = "bw:debug-hidden";

export function isDebugMode(): boolean {
  try {
    return localStorage.getItem(DEBUG_MODE_KEY) === "1";
  } catch {
    return false;
  }
}

export function setDebugMode(on: boolean): void {
  try {
    localStorage.setItem(DEBUG_MODE_KEY, on ? "1" : "0");
  } catch {
    // private mode / disabled storage — efekt jen do reloadu
  }
  window.dispatchEvent(new Event(DEBUG_CHANGED_EVENT));
}

/** Je bug ikona natrvalo skrytá z menu? (per-zařízení nastavení). */
export function isDebugHidden(): boolean {
  try {
    return localStorage.getItem(DEBUG_HIDDEN_KEY) === "1";
  } catch {
    return false;
  }
}

/** Skryje/zobrazí bug ikonu v menu. Při skrytí zároveň vypne aktivní debug mód. */
export function setDebugHidden(hidden: boolean): void {
  try {
    localStorage.setItem(DEBUG_HIDDEN_KEY, hidden ? "1" : "0");
    if (hidden) localStorage.setItem(DEBUG_MODE_KEY, "0");
  } catch {
    // private mode / disabled storage
  }
  window.dispatchEvent(new Event(DEBUG_CHANGED_EVENT));
}
